<template>
  <RoleFormPage mode="create" />
</template>

<script>
import RoleFormPage from './role-form-page.vue';

export default {
  name: 'createpermission',
  components: { RoleFormPage },
};
</script>
